// export const getBaseURL = () => (!process.env.NODE_ENV || process.env.NODE_ENV === "development") ? 'http://localhost/spectus-hrms-backend-laravel/public/api': 'https://akashpatel.co.in/spectus-hrms-backend-laravel/public/api/'
export const getBaseURL = () => 'https://akashpatel.co.in/spectus-hrms-backend-laravel/public/api/'

